module.exports = __webpack_public_path__ + "static/media/nilenp.e9b5d153.png";